const MILLISECOND = 1000;
const MINUTE = 60;

export const minutesToMilliseconds = (minutes: number): number =>
  minutes * MILLISECOND * MINUTE;

export const secondsToMilliseconds = (seconds: number): number =>
  seconds * MILLISECOND;
